import { Button } from '@faststore/ui'
import { Link as LinkGatsby } from 'gatsby'
import React, { useEffect, useState } from 'react'

import { MenuIcon } from '../../../assets/MenuIcon'
import { useHomeContent } from '../../../hooks/useHomeContent'
import useWindowDimensions from '../../../hooks/useWindowDimensions'

interface FirstColumnProps {
  setShowMenu: (value: boolean) => void
}

const FirstColumnHeader = ({ setShowMenu }: FirstColumnProps) => {
  const [width, setWidh] = useState(0)
  const { width: screenWidth } = useWindowDimensions()

  useEffect(() => {
    if (screenWidth) {
      setWidh(screenWidth)
    }
  }, [screenWidth])

  const { logo } = useHomeContent()

  return (
    <div className="navbar__first-column" data-testid="first-header-row">
      <Button
        className="navbar__menu"
        aria-label="Open Menu"
        onClick={() => setShowMenu(true)}
      >
        <MenuIcon color="var(--color-main-dark)" />
      </Button>
      <LinkGatsby
        to="/"
        aria-label="Home"
        title="Home"
        className="navbar__logo"
      >
        <div className="site-logotipo">
          <img
            src={width < 768 ? logo?.['image-mobile'] : logo?.image}
            alt={logo?.alt}
          />
        </div>
      </LinkGatsby>
    </div>
  )
}

export default FirstColumnHeader
